/**
 * Tag names of the HTML elements that honour the native `disabled` attribute.
 * A DOM fact, not a component concern: directives that project a `disabled`
 * input onto an arbitrary host element need it to decide whether the attribute
 * is valid markup on that host, or whether the state has to be emulated.
 *
 * Library-internal: imported by relative path, deliberately not re-exported
 * from the public barrel until something outside the library needs it.
 */
export const NATIVELY_DISABLEABLE_TAGS: readonly string[] = ['BUTTON', 'INPUT', 'SELECT', 'TEXTAREA', 'FIELDSET', 'OPTGROUP', 'OPTION'];

/** Whether `element` honours the native `disabled` attribute. */
export function supportsNativeDisabled(element: HTMLElement): boolean {
  return NATIVELY_DISABLEABLE_TAGS.includes(element.tagName);
}
